import { useAuthCtx } from '@/components/providers/auth-provider';

interface Props {
  children: React.ReactNode;
  disclose?: boolean;
}

export function SuperUserOnly({ children, disclose = false }: Props) {
  const { isSuperuser } = useAuthCtx();
  if (!isSuperuser) {
    return null;
  }
  if (!disclose) {
    return children;
  }
  return (
    <div className='relative'>
      {children}
      <div className='absolute top-0 right-0 text-xs font-medium text-red-500'>Solea Only</div>
    </div>
  );
}
